import React, { useState, useCallback } from 'react';
import { View } from 'react-native';

import { Text, TextInput } from '../../components';
import { PrimaryButton } from '../../design/components';
import useDialogSaveButton from '../../hooks/useDialogSaveButton';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const DocketTubDetail = ({
	modifyServiceDocket,
	tub: defaultValue,
	disabled = false,
	showTitle = true,
}) => {
	const styles = useThemedStyles(createStyles);
	const [tub, setTub] = useState(defaultValue);

	const onSave = useCallback(async () => {
		await modifyServiceDocket({ tub });
	}, [modifyServiceDocket, tub]);

	const { isSaveButtonPressed, onSaveButtonPress } = useDialogSaveButton(onSave);

	return (
		<View style={styles.container}>
			{showTitle && <Text style={styles.title} accessibilityRole="header">Tub</Text>}
			<TextInput
				autoFocus={true}
				value={tub || ''}
				onChange={setTub}
				selectTextOnFocus={true}
				placeholder="Enter tub reference"
			/>
			<PrimaryButton
				size="compact"
				label="Submit"
				onPress={onSaveButtonPress}
				loading={isSaveButtonPressed}
				disabled={disabled}
			/>
		</View>
	);
};

// Same layout as DocketCashBagDetail.
const createStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		paddingTop: space.sm,
		gap: space.md,
	},
	title: {
		...type.cardTitle,
		color: colors.text,
	},
});

export default DocketTubDetail;
